export default [
  // COA
  {
    path: '/acc/coa/list',
    name: 'acc-coa-list',
    component: () => import('@/views/accounting/coa/coa-list/CoaList.vue'),
    meta: {
      pageTitle: 'Master COA',
      breadcrumb: [
        {
          text: 'Master COA',
          active: true,
        },
      ],
      resource: 'acc-coa-list',
      action: 'read',
    },
  },
  {
    path: '/acc/coa/add',
    name: 'acc-coa-add',
    component: () => import('@/views/accounting/coa/coa-add/CoaAdd.vue'),
    meta: {
      pageTitle: 'Master COA',
      breadcrumb: [
        {
          text: 'Master COA',
          to: { name: 'acc-coa-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'acc-acc-coa-list',
      action: 'read',
    },
  },
  {
    path: '/acc/coa/edit/:id',
    name: 'acc-coa-edit',
    component: () => import('@/views/accounting/coa/coa-edit/CoaEdit.vue'),
    meta: {
      pageTitle: 'Master COA',
      breadcrumb: [
        {
          text: 'Master COA',
          to: { name: 'acc-coa-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'acc-acc-coa-list',
      action: 'read',
    },
  },
  // CASH
  {
    path: '/acc/cash/list',
    name: 'acc-cash-list',
    component: () => import('@/views/accounting/cash/cash-list/CashList.vue'),
    meta: {
      pageTitle: 'Master Kas & Bank',
      breadcrumb: [
        {
          text: 'Master Kas & Bank',
          active: true,
        },
      ],
      resource: 'acc-acc-cash-list',
      action: 'read',
    },
  },
  {
    path: '/acc/cash/add',
    name: 'acc-cash-add',
    component: () => import('@/views/accounting/cash/cash-add/CashAdd.vue'),
    meta: {
      pageTitle: 'Master Kas & Bank',
      breadcrumb: [
        {
          text: 'Master Kas & Bank',
          to: { name: 'acc-cash-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'acc-acc-cash-list',
      action: 'read',
    },
  },
  {
    path: '/acc/cash/edit/:id',
    name: 'acc-cash-edit',
    component: () => import('@/views/accounting/cash/cash-edit/CashEdit.vue'),
    meta: {
      pageTitle: 'Master Kas & Bank',
      breadcrumb: [
        {
          text: 'Master Kas & Bank',
          to: { name: 'acc-cash-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'acc-cash-list',
      action: 'read',
    },
  },

  // ARUS KAS
  {
    path: '/acc/cashflow/list',
    name: 'acc-cashflow-list',
    component: () => import('@/views/accounting/cash-flow/cash-flow-list/CashFlowList.vue'),
    meta: {
      pageTitle: 'Laporan Arus Kas',
      breadcrumb: [
        {
          text: 'Laporan Arus Kas',
          active: true,
        },
      ],
      resource: 'acc-cashflow-list',
      action: 'read',
    },
  },
  {
    path: '/acc/cashflow/print',
    name: 'print-cashflow',
    component: () => import('@/views/feature/PrintCashFlow.vue'),
    meta: {
      resource: 'acc-cashflow-list',
      action: 'read',
    },
  },
  {
    path: '/acc/cashflow/mutation',
    name: 'acc-cashflow-mutation',
    component: () => import('@/views/accounting/cash-flow/cash-flow-mutation/CashFlowMutation.vue'),
    meta: {
      pageTitle: 'Laporan Arus Kas',
      breadcrumb: [
        {
          text: 'Laporan Arus Kas',
          to: { name: 'acc-cashflow-list' },
        },
        {
          text: 'Mutasi',
          active: true,
        },
      ],
      resource: 'acc-cashflow-list',
      action: 'read',
    },
  },
  {
    path: '/acc/cashflow/create',
    name: 'acc-cashflow-create',
    component: () => import('@/views/accounting/cash-flow/cash-flow-create/CashFlowCreate.vue'),
    meta: {
      pageTitle: 'Laporan Arus Kas',
      breadcrumb: [
        {
          text: 'Laporan Arus Kas',
          to: { name: 'acc-cashflow-list' },
        },
        {
          text: 'Transaksi',
          active: true,
        },
      ],
      resource: 'acc-cashflow-list',
      action: 'read',
    },
  },
  // JOURNAL
  {
    path: '/acc/journal/list',
    name: 'acc-journal-list',
    component: () => import('@/views/accounting/journal/journal-list/JournalList.vue'),
    meta: {
      pageTitle: 'Jurnal Umum',
      breadcrumb: [
        {
          text: 'Jurnal Umum',
          active: true,
        },
      ],
    },
  },
  {
    path: '/acc/journal/edit/:id',
    name: 'acc-journal-edit',
    component: () => import('@/views/accounting/journal/journal-edit/JournalEdit.vue'),
    meta: {
      pageTitle: 'Jurnal Umum',
      breadcrumb: [
        {
          text: 'Jurnal Umum',
          to: { name: 'acc-journal-list' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      resource: 'acc-journal-list',
      action: 'read',
    },
  },
  {
    path: '/acc/balance/list',
    name: 'acc-balance-list',
    component: () => import('@/views/accounting/balance/balance-list/BalanceList.vue'),
    meta: {
      pageTitle: 'Laporan Neraca',
      breadcrumb: [
        {
          text: 'Laporan Neraca',
          active: true,
        },
      ],
    },
  },
]
